module.exports = __webpack_public_path__ + "media/images/pages/fcr/lab-7-45f2990a3783bf38a2ad5df12c5a6512.png";